import { Component, OnInit } from '@angular/core';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';

@Component({
  selector: 'app-nutzungsbedingungen',
  templateUrl: './nutzungsbedingungen.component.html',
  styleUrls: ['./nutzungsbedingungen.component.css'],
})
export class NutzungsbedingungenComponent implements OnInit {
  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;

  constructor() {}

  ngOnInit(): void {
  }
}
